import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { LessThanTenDivider } from '../../specials';

Builder.registerComponent(LessThanTenDivider, {
  name: BUILDER_DIVIDER_NAMES.LipsOrUnderArmsDivider,
});
